export const SUMBIT_PIXALL_ID = 'SUBMIT_PIXALL_ID';